/**
 * Global Company Context Mismatch Modal
 *
 * Mounted once into document.body at app startup (via app.js) so it is
 * available on ALL pages — pure Angular pages included — not just pages
 * that happen to load a Vue component.
 *
 * Listens for the 'companyContextMismatch' CustomEvent dispatched by both:
 *   - the axios response interceptor (main.js) for Vue/axios calls
 *   - the Angular $http versionAndAuthInterceptor for Angular $http calls
 */

import { defineComponent, h, reactive } from 'vue';
import { createVueIsland } from '@/createVueIsland';
import CompanyContextMismatchModal from '@/components/modals/CompanyContextMismatchModal.vue';
const _mismatchState = reactive({
  show: false
});

// Render function, not a `template:` string: runtime template compilation needs eval, which our
// CSP blocks, and the modal would then silently never render.
const GlobalMismatchModal = defineComponent({
  setup() {
    const handleReload = () => {
      // clearContext is a no-op here; the page will reload
    };
    return () => h(CompanyContextMismatchModal, {
      show: _mismatchState.show,
      onReload: handleReload
    });
  }
});
const host = document.createElement('div');
document.body.appendChild(host);
createVueIsland(GlobalMismatchModal).mount(host);
let mismatchHandled = false;
window.addEventListener('companyContextMismatch', () => {
  if (mismatchHandled) return;
  // If HeaderComponent is mounted (Vue pages), it owns the modal — defer to it.
  if (window.__companyContextModalActive) return;
  mismatchHandled = true;
  _mismatchState.show = true;
});